import { useState, useEffect } from 'react';

const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const debounceHandler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => clearTimeout(debounceHandler);
  }, [value, delay]);

  return [debouncedValue, setDebouncedValue];
};

const useDebouncedState = (initialValue, delay) => {
  if (!delay) throw Error('useDebouncedState requires delay');

  const [state, setStateDebounced] = useState(initialValue);

  const [debouncedState, setDebouncedState] = useDebounce(state, delay);

  return [debouncedState, setStateDebounced, setDebouncedState];
};

export default useDebouncedState;
